/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_Wrong_PasswordInputs */

const en_login_error_wrong_password = /** @type {(inputs: Login_Error_Wrong_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorrect password.`)
};

const fr_login_error_wrong_password = /** @type {(inputs: Login_Error_Wrong_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mot de passe incorrect.`)
};

const de_login_error_wrong_password = /** @type {(inputs: Login_Error_Wrong_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falsches Passwort.`)
};

const it_login_error_wrong_password = /** @type {(inputs: Login_Error_Wrong_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password errata.`)
};

const ru_login_error_wrong_password = /** @type {(inputs: Login_Error_Wrong_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неверный пароль.`)
};

const es_login_error_wrong_password = /** @type {(inputs: Login_Error_Wrong_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contraseña incorrecta.`)
};

const zh_cn2_login_error_wrong_password = /** @type {(inputs: Login_Error_Wrong_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`密码错误。`)
};

const ja_login_error_wrong_password = /** @type {(inputs: Login_Error_Wrong_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスワードが間違っています。`)
};

const hi_login_error_wrong_password = /** @type {(inputs: Login_Error_Wrong_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गलत पासवर्ड।`)
};

const pt_pt2_login_error_wrong_password = /** @type {(inputs: Login_Error_Wrong_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senha incorreta.`)
};

/**
* | output |
* | --- |
* | "Incorrect password." |
*
* @param {Login_Error_Wrong_PasswordInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_error_wrong_password = /** @type {((inputs?: Login_Error_Wrong_PasswordInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_Wrong_PasswordInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_error_wrong_password(inputs)
	if (locale === "de") return de_login_error_wrong_password(inputs)
	if (locale === "it") return it_login_error_wrong_password(inputs)
	if (locale === "ru") return ru_login_error_wrong_password(inputs)
	if (locale === "es") return es_login_error_wrong_password(inputs)
	if (locale === "zh-CN") return zh_cn2_login_error_wrong_password(inputs)
	if (locale === "ja") return ja_login_error_wrong_password(inputs)
	if (locale === "hi") return hi_login_error_wrong_password(inputs)
	if (locale === "pt-PT") return pt_pt2_login_error_wrong_password(inputs)
	return en_login_error_wrong_password(inputs)
});